'use client'

import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { Suspense } from 'react'
import { Logo } from '~/app/_components/Logo'
import { AuthProviderStep } from '~/app/_features/join/AuthProviderStep'

function AuthPageContent() {
  const router = useRouter()

  const handleProviderSelected = (
    _provider: 'google' | 'email',
    _user: { uid: string; email: string | null; displayName: string | null }
  ) => {
    router.push('/app/caregivers')
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="flex justify-center px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-2xl">
          <div className="text-center mb-8">
            <Link href="/" aria-label="Home" className="inline-block">
              <Logo className="h-16 w-auto mx-auto" />
            </Link>
          </div>

          <div className="bg-white rounded-lg shadow-xl p-8 sm:p-10">
            <div className="text-center mb-6">
              <h2 className="text-2xl font-semibold text-gray-900">
                Welcome back
              </h2>
              <p className="mt-2 text-sm text-gray-600">
                Sign in to your Tigo account
              </p>
            </div>

            <AuthProviderStep onProviderSelected={handleProviderSelected} />

            <div className="mt-8 text-center">
              <p className="text-sm text-gray-600">
                Don&apos;t have an account?{' '}
                <Link href="/join" className="font-medium text-primary hover:text-primary/80">
                  Join Tigo
                </Link>
              </p>
            </div>

            <div className="mt-6 text-center text-xs text-gray-500">
              <p>
                By continuing, you agree to our{' '}
                <Link href="/terms" className="text-primary hover:underline">
                  Terms of Service
                </Link>{' '}
                and{' '}
                <Link href="/privacy" className="text-primary hover:underline">
                  Privacy Policy
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default function AuthPage() {
  return (
    <Suspense fallback={
      <div className="bg-gray-50 min-h-screen flex items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary"></div>
      </div>
    }>
      <AuthPageContent />
    </Suspense>
  )
}
